export default __webpack_public_path__ + "static/media/9t.1c975209.jpg";